import { useEffect, useState } from "react";
import { siteData, AboutData } from "@/store/siteData";
import { useImageUrl } from "@/hooks/useImageUrl";

export default function AboutHero() {
  const [data, setData] = useState<AboutData>(siteData.getAbout());

  useEffect(() => {
    const handler = () => setData(siteData.getAbout());
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const imgUrl = useImageUrl(data.heroImageId, data.heroImageUrl);
  const titleLines = data.heroTitle.split("\n");

  return (
    <section className="relative w-full h-[60vh] min-h-[480px] flex items-end">
      <div className="absolute inset-0">
        <img
          src={imgUrl}
          alt="C2TEK Hakkımızda"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/85 via-[#1E3A8A]/40 to-[#1E3A8A]/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/55 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 w-full pb-16">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-px w-12 bg-[#3B82F6]"></div>
          <span className="text-[#B8C5D8] text-xs font-semibold tracking-[0.3em] uppercase">{data.heroTagline}</span>
        </div>
        <h1 className="text-white font-black uppercase leading-none"
          style={{ fontSize: "clamp(36px, 6vw, 80px)", letterSpacing: "-0.02em" }}
        >
          {titleLines[0]}
          {titleLines[1] && (
            <><br /><span className="text-transparent" style={{ WebkitTextStroke: "1.5px #7B8FAF" }}>{titleLines[1]}</span></>
          )}
        </h1>
      </div>
    </section>
  );
}
